import { ComponentProps } from 'react';
import { Label, SliderOutput } from 'react-aria-components';
import Typography from '@alltrails/core/components/Typography';
import { SharedSliderProps } from './sharedSliderHelpers';
import styles from './styles/styles.module.scss';

type SliderHeaderProps = Pick<
  SharedSliderProps<any>,
  'headerValueTextVariant' | 'label' | 'labelTextVariant' | 'subHeader' | 'subHeaderTextVariant'
> & {
  sliderOutputChildren?: ComponentProps<typeof SliderOutput>['children'];
};

const SliderHeader = ({
  headerValueTextVariant = 'text200',
  label,
  labelTextVariant = 'heading200',
  sliderOutputChildren,
  subHeader,
  subHeaderTextVariant = 'text100'
}: SliderHeaderProps) => {
  const showHeader = label || sliderOutputChildren || subHeader;

  const renderedLabel = label ? (
    <Typography variant={labelTextVariant}>
      <Label className={styles.label}>{label}</Label>
    </Typography>
  ) : null;

  const renderedSubHeader = subHeader ? (
    <Typography className={styles.subHeader} variant={subHeaderTextVariant}>
      {subHeader}
    </Typography>
  ) : null;

  return showHeader ? (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        {renderedLabel || renderedSubHeader}
        {sliderOutputChildren && (
          <Typography variant={headerValueTextVariant}>
            <SliderOutput className={styles.output}>{sliderOutputChildren}</SliderOutput>
          </Typography>
        )}
      </div>
      {renderedLabel ? renderedSubHeader : null}
    </div>
  ) : null;
};

export default SliderHeader;
